import { UserOutlined, BankOutlined } from '@ant-design/icons';

/** آیا نوع کاربر حقوقی (سازمان) است؟ */
export const isOrganizationUserType = (userType) =>
  userType === 'organization' || userType === 'حقوقی';

/** آیکون متناسب با نوع حقیقی/حقوقی */
export const getLeadTypeIcon = (userType) =>
  isOrganizationUserType(userType) ? BankOutlined : UserOutlined;

/** استخراج user_type از رکورد سرنخ/معامله */
export const resolveRecordUserType = (record) =>
  record?.user_type || record?.lead?.user_type || record?.lead_user_type || null;
